<template>
  <li :id="msgItem.id">
    <div class="msgitem notice" v-if="showTime">
      <span>{{ handleDateTimeFormat(msgItem.send_time) }}</span>
    </div>
    <div v-if="msgItem.msgtype == 1" class="msgitem time">
      <span>{{ msgItem.msg }}</span>
    </div>
    <div v-else-if="msgItem.msgtype == 2" class="msgitem notice">
      <span>{{ msgItem.msg }}</span>
    </div>
    <msgItemShell
      v-else-if="isChatMessage"
      :msgItem="msgItem"
      :layout="messageLayout"
      :variant="messageVariant"
      @read-status-change="handleReadStatusChange">
      <!-- 3 文本消息 -->
      <textMessage
        v-if="msgItem.msgtype == 3"
        :msgItem="msgItem"
        :searchKeyWords="searchKeyWords" />
      <!-- 5 图片消息 -->
      <imageMessage v-else-if="msgItem.msgtype == 5" :msgItem="msgItem" />
      <!-- 6 视频消息 -->
      <videoMessage v-else-if="msgItem.msgtype == 6" :msgItem="msgItem" />
      <!-- 7 笔记消息 -->
      <noteMessage v-else-if="msgItem.msgtype == 7" :msgItem="msgItem" />
      <!-- 8 企业微信名片消息 -->
      <cardMessage v-else-if="msgItem.msgtype == 8" :msgItem="msgItem" />
      <!-- 9 语音消息 -->
      <audioMessage v-else-if="msgItem.msgtype == 9" :msgItem="msgItem" />
    </msgItemShell>
    <div v-else>
      <div v-if="msgItem.msgtype != 1 && msgItem.msgtype != 2">
        【暂不支持此消息类型】，{{ noSupportTip }}
      </div>
    </div>
  </li>
</template>
<script>
import { toRefs, onMounted, reactive, computed, inject } from "vue";
import imageMessage from "./imageMessage";
import textMessage from "./textMessage";
import cardMessage from "./cardMessage.vue";
import noteMessage from "./notemsg/noteMessage.vue";
import videoMessage from "./videomsg/index.vue";
import audioMessage from "./audiomsg/index.vue";
import msgItemShell from "./msgItemShell.vue";
import { useStore } from "vuex";
import { PLAT_TYPE_MENU_TOOL } from "@/constants/plattypemenu-const";

/** 使用卡片布局的消息类型：视频、笔记、语音 */
const CARD_LAYOUT_MSG_TYPES = [6, 7, 9];

export default {
  components: {
    textMessage,
    imageMessage,
    cardMessage,
    noteMessage,
    videoMessage,
    audioMessage,
    msgItemShell,
  },
  props: {
    msgItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    upMsgTime: {
      type: String,
      default: () => {
        return "";
      },
    },
    searchKeyWords: { type: String },
  },
  emits: ["read-status-change"],
  setup(props, { emit }) {
    let store = useStore();
    const momentUtil = inject("momentUtil");
    const data = reactive({
      active_item: 1,
    });

    const isChatMessage = computed(() => {
      const type = props.msgItem.msgtype;
      return [3, 5, 6, 7, 8, 9].includes(type);
    });

    const messageLayout = computed(() => {
      return CARD_LAYOUT_MSG_TYPES.includes(props.msgItem.msgtype) ? "card" : "bubble";
    });

    const messageVariant = computed(() => {
      return props.msgItem.msgtype == 9 ? "audio" : "default";
    });

    //当前选中平台
    const chatingPlatId = computed(() => {
      return store.state.chat_store.chat_plat_id;
    });

    const noSupportTip = computed(() => {
      let paltId = store.state.chat_store.chat_plat_id;
      switch (paltId) {
        case PLAT_TYPE_MENU_TOOL.DOUYIN.value:
          return "请到抖音 App 端查看";
        case PLAT_TYPE_MENU_TOOL.XIAOHS.value:
          return "请到小红书 App 端查看";
        case PLAT_TYPE_MENU_TOOL.WEIXIN.value:
          return "请到微信客服 App 端查看";
        case PLAT_TYPE_MENU_TOOL.KUAISHOU.value:
          return "请到快手 App 端查看";
        default:
          return "";
      }
    });

    const showTime = computed(() => {
      if (!props.msgItem.send_time) {
        return false;
      }
      if (!props.upMsgTime) {
        return true;
      }
      let time1 = momentUtil.moment(props.msgItem.send_time, "YYYY-MM-DD HH:mm:ss");
      let time2 = momentUtil.moment(props.upMsgTime, "YYYY-MM-DD HH:mm:ss");
      let diff = time1.diff(time2, "seconds");
      if (Math.abs(diff) > 60) {
        return true;
      }
      return false;
    });

    const handleDateTimeFormat = (dateStr) => {
      if (!dateStr) {
        return "";
      }
      let timeMoment = momentUtil.moment(dateStr, "YYYY-MM-DD HH:mm:ss");
      if (timeMoment.isSame(momentUtil.moment(), "day")) {
        return timeMoment.format("HH:mm");
      } else {
        return dateStr;
      }
    };

    const handleReadStatusChange = (readMsgItem) => {
      emit("read-status-change", readMsgItem);
    };

    onMounted(() => {});

    return {
      ...toRefs(data),
      chatingPlatId,
      noSupportTip,
      showTime,
      handleDateTimeFormat,
      isChatMessage,
      messageLayout,
      messageVariant,
      handleReadStatusChange,
    };
  },
};
</script>

<style lang="scss" scoped></style>
